import { render, staticRenderFns } from "./Blog-post.vue?vue&type=template&id=6da6ffa2&scoped=true&"
import script from "./Blog-post.vue?vue&type=script&lang=js&"
export * from "./Blog-post.vue?vue&type=script&lang=js&"
import style0 from "./Blog-post.vue?vue&type=style&index=0&id=6da6ffa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da6ffa2",
  null
  
)

export default component.exports